import { useOverlayContext } from "../../../contexts";
import { EditDocumentModal } from "../EditDocumentModal/EditDocumentModal";
import { jsx as _jsx } from "react/jsx-runtime";
export const useEditQuillLegalTerms = () => {
  const {
    showModal
  } = useOverlayContext();
  const editQuillLegalTerms = async (legalTerm, variant) => {
    await showModal({
      closeOnEscapeKey: true,
      closeOnClickOutside: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/_jsx(EditDocumentModal, {
          variant: variant,
          legalTermsId: legalTerm.id,
          initialName: legalTerm.name,
          initialContent: {
            type: 'quill-delta',
            value: legalTerm.richTextContent
          },
          dismissModal: dismissModal
        });
      }
    });
  };
  return {
    editQuillLegalTerms
  };
};